import { Component, Input, OnInit } from '@angular/core';
import { DateSearchRange } from '../../../models/net/date-search-range';

@Component({
    selector: 'app-date-range-field',
    templateUrl: './date-range-field.component.html',
    styleUrls: ['./date-range-field.component.css']
})

export class DateRangeFieldComponent implements OnInit {

    @Input() public fromLabel: string = "From";
    @Input() public toLabel: string = "To";
    @Input() public dateRange: DateSearchRange = new DateSearchRange();

    public constructor() { }

    public ngOnInit(): void { }
}
